export default {
  'highlights-heading':
    'Un espace pour partager des idées, des suggestions et - pourquoi pas - vous inspirer de vos cadeaux',
}
